module.exports = __webpack_public_path__ + "img/placeholder.16df0d04.jpg";